import { defineStore } from "pinia";

export const useStyleStore = defineStore("style", {
  state: () => ({
    primaryColor: "#007bff", // Default button color (Bootstrap primary blue)
    secondaryColor: "#007bff", // Default button color (Bootstrap primary blue)
    coverImageUrl: "", // Default cover image
    logoImageUrl: "", // Default logo image
    voucherImageUrl: "",
    loading: false,
    error: null,
    storeInfo: {},
    generalInfo: {}
  }),
  actions: {

    async fetchStyleConfig(storeId,router) {
      this.loading = true;
      this.error = null;
      try {
        // Replace with your actual API endpoint
        const response = await fetch(
          `${process.env.VUE_APP_API_URL}/api/v1/outlets/${storeId}/get_online_voucher_settings`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (storeId && response.status == 404) {
          // Redirect to another page, e.g., a "Not Found" page
          // If using Vue Router, you can do:
          router.push('/');
          return; // Stop further execution
        }
        if (!response.ok) {
          throw new Error("Failed to fetch style configuration");
        }

        const data = await response.json();
        this.primaryColor =
          data.online_voucher_settings.theme.primaryColor || this.primaryColor;
        this.secondaryColor =
          data.online_voucher_settings.theme.secondaryColor ||
          this.secondaryColor;
        this.coverImageUrl = data.banner_online_voucher || this.coverImageUrl;
        this.logoImageUrl = data.logo_online_voucher || this.logoImageUrl;
        this.voucherImageUrl = data.online_voucher_business_banner || this.voucherImageUrl
        this.storeInfo = data.store_info
        this.generalInfo = data.online_voucher_settings.general
        this.onlineVoucherSettings = data.online_voucher_settings;
      } catch (error) {
        this.error = error.message;
        console.error("Error fetching style config:", error);
      } finally {
        this.loading = false;
      }
    },
  },
});
